import { tv, VariantProps } from "tailwind-variants";

import {
  alignVariants,
  colorVariants,
  responsiveVariants,
  weightVariants,
  whitespaceVariants,
} from "../constant";

export const textControlVariants = tv(
  {
    base: "font-display",
    variants: {
      size: {
        1: "text-[length:--text-new-lg] md:text-[length:--text-new-2xl] uppercase",
        2: "text-[length:--text-new-base] md:text-[length:--text-new-xl]",
        3: "text-[length:--text-new-sm] md:text-[length:--text-new-lg] uppercase",
        4: "text-[length:--text-new-xs] md:text-[length:--text-new-base] font-default font-normal",
        5: "text-[length:--text-new-xs] md:text-[length:--text-new-base] uppercase",

      },
      color: {
        ...colorVariants,
      },
      align: {
        ...alignVariants,
      },
      whitespace: {
        ...whitespaceVariants,
      },
      weight: {
        ...weightVariants,
      },
    },
    defaultVariants: {
      size: 1,
      align: "default",
      whitespace: "normal",
    },
  },
  { responsiveVariants: [ ...responsiveVariants ],

  },
);

export type TextControlVariantsProps = VariantProps<typeof textControlVariants>;
const textControlStyles = (variants: TextControlVariantsProps) => textControlVariants(variants);

export default textControlStyles;
